<div class="header">
	<ul class="header-item breakpoint-wrapper">
		<li class="header-item-user" (click)="openUserActionsDialog()" #userActions>
			<img src="../../../../assets/header/WHITE_ACCOUNT.svg" alt="user-logo" class="header-item-user-img">
			<span class="header-item-user-title" *ngIf="(user$ | async) as user"> {{ user ? user.email : 'login' }} </span>
		</li>
	</ul>
</div>